import { useStore } from 'effector-react';
import { routes } from 'features/verify/routes';
import { ErrorLayout } from 'features/verify/ui/error-layout';

import { navigate } from 'libs/router';
import { css } from 'linaria';
import { clearError, mapErrorName, setError } from 'model/error.model';
import { verificationCancel } from 'model/flows/verification.model';
import { captureErrorFx } from 'model/helpers/analytics.model';
import { sendEvent } from 'model/helpers/events.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { sessionConfig$ } from 'model/session.model';
import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Button } from 'ui/atoms/button';
import { Text } from 'ui/typography';

const mediaDevices = navigator.mediaDevices;
const getUserMedia = mediaDevices && mediaDevices.getUserMedia ? mediaDevices.getUserMedia.bind(mediaDevices) : null;

export const AccessDeclined = () => {
	const t = useLocalization();
	const session = useStore(sessionConfig$);
	const [start] = useState(Date.now());

	useEffect(() => {
		screenHistoryPush(ScreenName.camera_permissions_rejected);
		setTimeout(() => {
			sendEvent({ event: 'camera_rejected_screen_shown' });
		}, 20)
	}, []);

	const promptPermissions = async () => {
		sendEvent({ event: 'camera_rejected_retry_clicked' });
		try {
			await getUserMedia({
				video: {
					width: { min: 480 },
					height: { min: 640 },
				},
				audio: false,
			});
			clearError();
			sendEvent({
				event: 'camera_permissions_granted',
				event_attributes: {
					duration: Date.now() - start,
				},
			});
			navigate(routes.document);
		} catch (e) {
			const errorType = mapErrorName(e.name, true);
			captureErrorFx(e);
			sendEvent({
				event: 'camera_permissions_rejected',
				event_attributes: {
					screen: 'access_declined',
					error_type: e.name,
					duration: Date.now() - start,
				},
			});
			setError(errorType);
		}
	};

	const handleExit = () => {
		sendEvent({ event: 'camera_rejected_exit_clicked' });
		verificationCancel();
	};

	return (
		<ErrorLayout
			title={t('mobile.camera.declined.title')}
			description={t('mobile.camera.declined.description')}
		>
			<Text
				style={{
					textAlign: 'center',
					marginBottom: 32,
				}}
			>
				{t('mobile.camera.declined.hint')}
			</Text>
			<Button
				onClick={handleExit}
				type={'default'}
				className={btn}
				name={'mobile.camera.declined.btn.exit'}
			>
				{t('mobile.camera.declined.btn.exit', {
					company: session.company,
				})}
			</Button>
			<Button
				name={'mobile.camera.declined.btn'}
				onClick={promptPermissions}
			>
				{t('mobile.camera.declined.btn')}
			</Button>
		</ErrorLayout>
	);
};

const btn = css`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 8px;
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	color: #262626;
	width: 100%;
`;
